import { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import infoIcon from '../../constants/icons/info_icon.png';
import arrowUpIcon from '../../constants/icons/arrow_up_icon.png';
import arrowDownIcon from '../../constants/icons/arrow_down_icon.png';

const DJackInfoCard = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className="card">
      <div className="cardTitle">
        <img src={infoIcon} alt="infoIcon" className="gameInfoIcon" />
        Game Info
      </div>
      <AnimatePresence key="gameInfoButton" exitBeforeEnter>
        {!isOpen ? (
          <motion.button
            key="arrowDownButton"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="gameInfoButton"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          >
            <img
              src={arrowDownIcon}
              alt="arrowDownIcon"
              className="gameInfoCollapseIcon"
            />
          </motion.button>
        ) : (
          <motion.button
            key="arrowUpButton"
            type="button"
            onClick={() => setIsOpen(!isOpen)}
            className="gameInfoButton"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 1.2 }}
          >
            <img
              src={arrowUpIcon}
              alt="arrowUpIcon"
              className="gameInfoCollapseIcon"
            />
          </motion.button>
        )}
      </AnimatePresence>
      <motion.div
        key="gameInfoCard"
        initial="collapsed"
        animate={isOpen ? 'open' : 'collapsed'}
        exit="collapsed"
        variants={{
          open: {
            height: '420px',
            transition: {
              delayChildren: 0.6,
              staggerChildren: 0.6,
              duration: 1.2,
              ease: 'easeInOut'
            }
          },
          collapsed: {
            height: '0px'
          }
        }}
        transition={{ duration: 1.2, ease: 'easeInOut' }}
      >
        {isOpen && (
          <>
            <motion.div
              key="gameInfoHowToPlay"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="innerCard"
            >
              <div className="innerCardTitle">How to Play</div>
              <ol className="gameInfoCardBody">
                <li>
                  Download <a href="https://metamask.io/">MetaMask</a> digital
                  wallet and press login.
                </li>
                <li>Create or join a room.</li>
                <li>Press start when there are two players.</li>
                <li>Roll the dice to get points.</li>
                <li>If you pass 13 points you automatically lose.</li>
                <li>Try to have higher points than your opponent to win.</li>
                <li>Press collect to claim the prize.</li>
              </ol>
            </motion.div>
            <motion.div
              key="gameInfoRules"
              variants={{
                open: {
                  opacity: 1
                },
                collapsed: { opacity: 0 }
              }}
              className="innerCard"
            >
              <div className="innerCardTitle">Rules</div>
              <ul className="gameInfoCardBody">
                <li>Every game is an anonymous smart contract.</li>
                <li>The game is played with two players.</li>
                <li>Creator of the contract decides the game fee.</li>
                <li>Players accumulate points by rolling the dice.</li>
                <li>
                  If the player pass 13 points, he will automatically lose.
                </li>
                <li>
                  The game will end if there is no response for a set period.
                </li>
                <li>The player with higher points wins the game.</li>
                <li>Total prize is transferred to the winner.</li>
              </ul>
            </motion.div>
          </>
        )}
      </motion.div>
    </div>
  );
};

export default DJackInfoCard;
